import { useRef } from 'react';
export var useTrackedRef = function useTrackedRef(value) {
  var ref = useRef(value);
  ref.current = value;
  return ref;
};